export default __webpack_public_path__ + "static/media/banner-mobile.9cf080eb.mp4";